import { Navigate, Route, Routes } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import LayoutRoutes from "./LayoutRoutes";
import { authRoutes } from "./AuthRoutes";
import Login from "../Pages/Authentication/Login";

const Routers = () => {
  const login = localStorage.getItem("login") === "true";

  return (
      <Routes>
        {login ? (
          <Route
            path={`` || '/'}
            element={
              <Navigate to={`/dashboard`} replace />
            }
          />
        ) : null}
        <Route path={"/"} element={<PrivateRoute />}>
          <Route path={`/*`} element={<LayoutRoutes />} />
        </Route>
        {authRoutes.map(({ path, Component }, i) => (
          <Route
            path={path}
            element={login ? <Navigate to={`/dashboard`} replace /> : Component}
            key={i}
          />
        ))}
        <Route
          path={`/login`}
          element={login ? <Navigate to={`/dashboard`} replace /> : <Login />}
        />
      </Routes>
  );
};

export default Routers;
